import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics/index.js";

const DEBOUNCE_MS = 250;

export function usePageViewTracking(enabled: boolean): void {
  const { pathname, search } = useLocation();
  const lastTrackedRef = useRef<string | null>(null);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled) return;
    const full = pathname + search;
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => {
      if (lastTrackedRef.current === full) return;
      lastTrackedRef.current = full;
      trackPageView(full);
    }, DEBOUNCE_MS);
    return () => {
      if (timerRef.current !== null) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [enabled, pathname, search]);
}
